export const headCells= [
                    {
                      id: "branch_name",
                      numeric: false,
                      disablePadding: true,
                      label: "Branch Name",
                    },
                    {
                      id: "isMainBranch",
                      numeric: true,
                      disablePadding: false,
                      label: "MainBranch",
                    },
                    {
                      id: "address",
                      numeric: true,
                      disablePadding: false,
                      label: "Address",
                    },
                    {
                      id: "city",
                      numeric: true,
                      disablePadding: false,
                      label: "City",
                    },
                    {
                      id: "status",
                      numeric: true,
                      disablePadding: false,
                      label: "Status",
                    },
                    {
                      id: "email",
                      numeric: true,
                      disablePadding: false,
                      label: "Email",
                    },
                    {
                      id: "pincode",
                      numeric: true,
                      disablePadding: false,
                      label: "Pincode",
                    },
                    
                   
                   
                    {
                      id: "state",
                      numeric: true,
                      disablePadding: false,
                      label: "State",
                    },
                    {
                      id: "country",
                      numeric: true,
                      disablePadding: false,
                      label: "Country",
                    },
                    
                   
                    {
                      id: "phone",
                      numeric: true,
                      disablePadding: false,
                      label: "Phone",
                    },
                  ];